// extracted by mini-css-extract-plugin
export default {"panelContainer":"src-views-editor-containers-PagedPanel-PagedPanel__panelContainer--NUcLI"};